// intentially set the properties to be lower case, we are using it as a map object
export const MetricEventName = {
	taskaction: 'TaskAction',
	appaction : 'AppAction',
	getenvInfo : 'GetEnvInfo',
	apploaded : 'AppLoaded',
	itemclick : 'FeatureClick',			// convert itemclick to FeatureClick
	featureclick : 'FeatureClick',
	firstrun : 'FirstRun',
	articledisplay : 'ArticleDisplay',
	pageview : 'PageView',
	itemview : 'ItemView',
	docclick : 'ArticleClick', // convert docclick => ArticleClick
	docview : 'ArticleView', // convert docview => ArticleView
	articleclick : 'ArticleClick',
	articleview : 'ArticleView',
	settingupdate : 'SettingUpdate',
	userfeedback : 'UserFeedback',
	contentdisplay : 'ContentDisplay',
	appactivation: 'AppActivation',
	unknown : 'Unknown'
};
Object.freeze(MetricEventName);
